export default __webpack_public_path__ + "images/CJ.86d3787.png";